import LoadingButton from "@mui/lab/LoadingButton";
import { Alert, Button, Fade, Grid, Typography } from "@mui/material";
import { Field, Form, useField } from "react-final-form";
import { z } from "zod";
import InputField from "../../../../components/Form/InputField";
import SelectField, { getDefaultValue, SelectOption } from "../../../../components/Form/SelectField/SelectField";
import { NoteTypeEnum } from "../../../../__generated__/graphql";
interface NoteType {
    label: string,
    value: string
}
const REFERRAL_NOTE_TYPE: NoteType[] =
    [{
        label: "Referral",
        value: NoteTypeEnum.Referral
    },
    { label: "No Referral Needed", value: NoteTypeEnum.NoReferral },
    { label: "Monitoring In House", value: NoteTypeEnum.Monitoring }
    ]
const noteSchema = z.object({
    note: z.string().trim().max(2000).optional(),
    noteType: z.union([z.literal("REFERRAL"), z.literal("NO_REFERRAL"), z.literal("MONITORING")])
});

const mapSelectOptions = (options: any[]): SelectOption[] => options.map(x => ({
    label: x.label,
    value: x.value,
    isDefault: x.value === "REFERRAL"
}))
type ReferralFormProps = z.infer<typeof noteSchema>;

const formValidator = <T extends z.ZodType<any, any>>(schema: T) => (values: any) => {
    try {
        schema.parse(values);
    } catch (err) {
        return (err as z.ZodError).formErrors.fieldErrors;
    }
};

export default function ReferralForm({ onCancel, onSubmit }: { onCancel: () => void, onSubmit: (values: ReferralFormProps) => void }) {
    const noteOptions: SelectOption[] = (mapSelectOptions(REFERRAL_NOTE_TYPE))
    return (
        <Form initialValues={{ noteType: getDefaultValue(noteOptions) }}
            onSubmit={(values: ReferralFormProps) => onSubmit(values)} validate={formValidator(noteSchema)}
            render={({ form, submitting, submitError, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Typography sx={{ textAlign: "center" }}>What type of referral would you like to make?</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Field name="noteType" render={(fieldProps) => (
                                <SelectField options={noteOptions} {...fieldProps} />
                            )} />
                        </Grid>
                        <Grid size={12}>
                            <Typography>Add any additional notes here</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Field name="note" render={(fieldProps) => (
                                <InputField
                                    label="Note"
                                    rows={5}
                                    multiline
                                    fullWidth
                                    {...fieldProps} />
                            )} />
                        </Grid>
                        {submitError && (
                            <Fade appear in timeout={250}>
                                <Grid size={12}>
                                    <Alert variant="filled" severity="error">
                                        {submitError}
                                    </Alert>
                                </Grid>
                            </Fade>
                        )}
                        <Grid container sx={{ marginTop: 2 }}>
                            <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
                                <Button variant="contained" onClick={onCancel}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
                                <LoadingButton
                                    type="submit"
                                    loading={submitting}
                                    variant="contained"
                                >
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </form >
            )
            }
        />
    );
}